import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

/**
 * Fetches all activity-log rows targeting a file permission (image) — every
 * VIEW_IMAGE, via the backend's gsi2 target index — so the UI can show who has
 * viewed the image. The backend enforces ACTIVITY_LOG_VIEW and resolves the
 * project's business_id. Returns the API payload (`{ items }`), newest-first.
 */
export const getActivityLogsForImage = async ({
  projectId,
  filePermissionId,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const apiPath = `activity-log/project/${projectId}/image/${filePermissionId}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
